module.exports = __webpack_public_path__ + "static/img/payment-imgTitle.b5b9b81.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/payment-imgTitle.png
// module id = rwjG
// module chunks = 0